import { TextField } from '@mui/material';
import { validateDate } from '@src/Objects/Helper';
import React from 'react';

interface DateInputProps {
    value: Date | undefined;
    disabled?: boolean;
    helperText?: string;
    onChange(val: Date | undefined): void;
}

/**
 * Modern DateInput component with MUI styling.
 *
 * @param {DateInputProps} props - The props for configuring the DateInput component.
 * @returns {JSX.Element} - The rendered DateInput component.
 */
export default function DateInput(props: DateInputProps) {
    const value = typeof props.value === 'string' ? new Date(props.value) : props.value;

    // Validate date before calling toISOString to prevent "Invalid time value" error
    const isValidDate = value instanceof Date && !isNaN(value.getTime());
    const dateString = isValidDate ? value.toISOString().substr(0, 10) : '';

    return (
        <TextField
            type="date"
            size="small"
            disabled={props.disabled}
            helperText={props.helperText}
            value={dateString}
            onChange={(e) => {
                const newDate = validateDate(e.target.value);
                props.onChange(newDate);
            }}
            sx={{
                width: 'auto',
                minWidth: '160px',
                '& .MuiInputBase-input': {
                    fontSize: '0.875rem',
                },
                '& .MuiInputBase-root': {
                    borderRadius: 2,
                },
            }}
        />
    );
}
